"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwaDeliveryBlockWidget = bwaDeliveryBlockWidget;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../../../utils/utils");
var _constants = require("../../../constants/constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function generateBwADeliveryBlockUrl(ecpSkuQuantity, storeId, variantId) {
  var postalCode = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.PINCODE);
  var params = _objectSpread({
    ecp: _constants.ECP,
    ecpSkuId: variantId,
    ecpSkuQuantity: ecpSkuQuantity,
    ecpItemId: variantId,
    ecpShopId: storeId,
    isEditable: true,
    source: _constants.SOURCE.WEBSITE
  }, postalCode && {
    postalCode: postalCode
  });
  return (0, _utils.generateUrlWithParams)(_constants.WIDGET_ENDPOINTS.DELIVERY_BLOCK, params);
}
function bwaDeliveryBlockWidget(id, cssClass, ecpSkuQuantity, storeId, variantId) {
  return (0, _utils.generateIframe)(id, cssClass, generateBwADeliveryBlockUrl(ecpSkuQuantity, storeId, variantId));
}
//# sourceMappingURL=bwa-delivery-block.js.map
